var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 100,
    viewBox: "0 0 72 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 13,
    fill: "#F3F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9157 86.112H15.6197V99H16.9157V95.796L19.4537 92.646L23.2337 99H24.7457L20.2997 91.566L24.6737 86.112H23.1257L16.9157 93.87V86.112ZM25.2494 94.644C25.2494 97.29 27.1214 99.216 29.6774 99.216C32.2334 99.216 34.1054 97.29 34.1054 94.644C34.1054 91.98 32.2334 90.054 29.6774 90.054C27.1214 90.054 25.2494 91.98 25.2494 94.644ZM26.5094 94.626C26.5094 92.61 27.8054 91.17 29.6774 91.17C31.5314 91.17 32.8454 92.61 32.8454 94.626C32.8454 96.678 31.5314 98.1 29.6774 98.1C27.8054 98.1 26.5094 96.678 26.5094 94.626ZM38.002 99V91.332H39.748V90.288H38.002V87.534H36.778V90.288H35.032V91.332H36.778V99H38.002ZM42.6613 99V85.878H41.4193V99H42.6613ZM45.9148 87.894C46.4188 87.894 46.8508 87.48 46.8508 86.976C46.8508 86.472 46.4188 86.04 45.9148 86.04C45.4108 86.04 44.9968 86.472 44.9968 86.976C44.9968 87.48 45.4108 87.894 45.9148 87.894ZM45.3028 99H46.5448V90.288H45.3028V99ZM50.3769 99V94.446C50.3769 92.484 51.3849 91.188 53.1669 91.188C54.6069 91.188 55.5249 91.908 55.5249 93.942V99H56.7669V93.672C56.7669 91.476 55.7769 90.054 53.3829 90.054C52.1229 90.054 50.9709 90.684 50.3949 91.8L50.2149 90.288H49.1349V99H50.3769Z",
    fill: "#303030"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4343_14836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.601 60L37.203 37.0005L60 60H14.601ZM12 12H36L12 37.0005V12ZM38.7975 12L12 40.0005V60L60 12H38.7975Z",
    fill: "#2342E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4343_14836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/Kotlin.0d77947fb289e9389e7ed2da67996754.svg";
export { ForwardRef as ReactComponent };